import {axios} from "@/utilites/api";
import Config from "@/common/config";

const getClient = (userId) => {
    return axios.get(Config.apiURL + '/settings/clients?id=' + userId.id)
}

const getEmailTemplates = () => {
    return axios.get(Config.apiURL + '/postman/api/v1/email-templates')
}

const updateEmailTemplate = (parameters) => {
    return axios.put(Config.apiURL + '/postman/api/v1/email-templates', parameters)
}

const createEmailTemplate = (parameters) => {
    return axios.post(Config.apiURL + '/postman/api/v1/email-templates', parameters)
}

const getCurrentEmailTemplate = (parameters) => {
    return axios.get(`${Config.apiURL}/postman/api/v1/email-templates/${parameters.id}`)
}

const deleteCurrentEmailTemplate = (parameters) => {
    return axios.delete(`${Config.apiURL}/postman/api/v1/email-templates/${parameters.id}`)
}

const followUp = (parameters) => {
    return axios.post(Config.apiURL + '/postman/api/v1/follow-up', parameters)
}

const sendBalloon = (parameters) => {
    return axios.post(Config.apiURL + '/settings/itinerary-requests/safari-balloon', parameters)
}

const sendPortableToilet = (parameters) => {
    return axios.post(Config.apiURL + '/settings/itinerary-requests/climbing-portable-toilet', parameters)
}

export default {
    getClient,
    getEmailTemplates,
    updateEmailTemplate,
    createEmailTemplate,
    getCurrentEmailTemplate,
    deleteCurrentEmailTemplate,
    followUp,
    sendBalloon,
    sendPortableToilet
}